import { isPaidSubscription } from '@/lib/quota/isPaidSubscription';
import {
  resolveWalletRenewalEligibility,
  type WalletRenewalSubscriptionLike,
} from './resolveWalletRenewalEligibility';

export type RenewalCouponLinkAction =
  | { action: 'apply'; variant: 'pix' | 'grant'; code: string }
  | { action: 'plans'; code: string }
  | { action: 'unsupported'; code: string };

/** Decides what a `?coupon=` renewal link should do for the viewer. */
export function resolveRenewalCouponLink({
  subscription,
  code,
  now,
}: {
  subscription: WalletRenewalSubscriptionLike | null | undefined;
  code: string | null | undefined;
  now: Date;
}): RenewalCouponLinkAction | null {
  const normalized = (code ?? '').trim().toUpperCase();
  if (!normalized || !subscription) return null;

  const eligibility = resolveWalletRenewalEligibility({ subscription, now });
  if (eligibility.ok) {
    return { action: 'apply', variant: eligibility.path, code: normalized };
  }
  if (!isPaidSubscription(subscription)) {
    return { action: 'plans', code: normalized };
  }
  return { action: 'unsupported', code: normalized };
}
